module.exports = __webpack_public_path__ + "static/media/06_tn.9660686d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/06_tn.jpg
// module id = 436
// module chunks = 0